import { createFileRoute } from '@tanstack/react-router'

import { WebhookEventsPage } from '#/modules/system/webhook-events-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/webhook-events')({
  component: WebhookEventsPage,
  validateSearch: validateListSearch,
})
